import { PayloadAction } from "@reduxjs/toolkit";
import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {onUserAccessMenuSuccess, onCountryUserListSuccess} from "../slice/loginSlice";
import JWTInterceptor from "../../api/JWT/JWTInterceptor";
import { setLoader, setApplicationDetails } from "../slice/generalSlice";
import {
  getAppListConfig,
  appListStyleConfig,
} from "../../helpers/applistconfig.helper";

function* getApplicationDetails(): Generator<any, void, any> {
    console.log("yesss");
  yield put(setLoader(true));
  try {
    const response = yield JWTInterceptor.get(`${process.env.REACT_APP_USERACCESS_API_BASE_URL}Applications/UserApplications`);
    if (response.status === 200) {
      const moduleNav = response.data.map((item: any) => {
        return {
          ...item,
          icon: item.hasAccess? ((getAppListConfig(item.code)?.icon)):(getAppListConfig(item.code)?.iconDisabled),
        };
      });
      console.log("moduleNav", moduleNav);
      yield put(
        setApplicationDetails({
          value: moduleNav,
        })
      );
    } else {
    //   const errorData: Error = {
    //     status: response.status,
    //     message: response.data,
    //   };
    //   yield put(setError({ error: errorData }));
    }
  } catch (error) {
    // const errorData: Error = {
    //   status: RESPONSE_STATUS.EXCEPTION,
    //   message: "Something Went Wrong",
    // };
    // yield put(setError({ error: errorData }));
  } finally {
   yield put(setLoader(false));
  }
}


export function* watchgetApplicationDetails() {
  yield takeLatest("general/getApplicationDetails", getApplicationDetails);
}

